import { useQuery } from "@tanstack/react-query";
import { HomeApi } from "../api/home-api";

export const homeQueryKeys = {
  home: (teamExternalId: string) => ["home", teamExternalId],
};

export function useHomeQuery(teamExternalId: string) {
  return useQuery({
    queryKey: homeQueryKeys.home(teamExternalId),
    queryFn: () => HomeApi.getHome(teamExternalId),
  });
}
